import { BaseUserPublic } from "@/types/users"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import SocialLinks from "./SocialLinks"
import { AuthorAvatar } from "@/app/components/Avatar"
import TruncateText from "@/app/components/TruncatedText"
import AvatarGroup from "@/app/components/Avatar/Group/AvatarGroup"

export default function MultipleAuthorDisplay({
  authors,
}: {
  authors: BaseUserPublic[]
}) {
  const firstThreeAvatars = authors.filter((a) => a.avatar_url).slice(0, 3)

  return (
    <Dialog>
      <DialogTrigger className="flex flex-row">
        <AvatarGroup
          avatars={firstThreeAvatars}
          small
          text={`${authors[0].displayName.name} and ${authors.length - 1} other${authors.length > 2 ? "s" : ""}`}
        />
      </DialogTrigger>
      <DialogPortal>
        <DialogContent className="sm:max-w-[462px] max-h-132 overflow-y-scroll">
          <DialogHeader>
            <DialogTitle>Writers</DialogTitle>
          </DialogHeader>
          <div className="mt-8">
            {authors.map((author, i) => (
              <div key={i}>
                <AuthorRow author={author} />
                {i < authors.length - 1 && <hr className="my-4" />}
              </div>
            ))}
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}

function AuthorRow({ author }: { author: BaseUserPublic }) {
  return (
    <>
      <div className="flex items-center justify-between gap-2">
        <div className="max-w-full flex items-center gap-2">
          <AuthorAvatar user={author} size={40} className="h-10 w-10 " />
          <span className="max-w-48 text-foreground font-medium text-sm truncate">
            {author.displayName.name}
          </span>
        </div>
        <SocialLinks
          socials={author.social}
          walletAddress={author.lowercase_wallet_address}
        />
      </div>
      {author.authorBio && (
        <div className="mt-2">
          <TruncateText
            text={author.authorBio}
            maxLength={150}
            className="text-muted-foreground text-sm font-normal"
          />
        </div>
      )}
    </>
  )
}
